/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const futureStockDropdown = {
  header: 'Disponibilidad futura',
  quantity: 'Cantidad',
  noFutureStocks: 'Este producto no tiene información de disponibilidad futura.',
};

export const futureStock = {
  futureStockDropdown,
};
